import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import BottomBox from 'src/components/BottomBox/BottomBox'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ReadOnlyNotesBoxProps {
  notes: string
}

const ReadOnlyNotesBox: React.FC<ReadOnlyNotesBoxProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <BottomBox
      label={translate('Notes')}
      collapsible
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <span
        css={css`
          overflow-wrap: anywhere;
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )}
        `}
      >
        {props.notes}
      </span>
    </BottomBox>
  )
}

export default ReadOnlyNotesBox
